export default {"src":"/_next/static/media/0x4988a896b1227218e4a686fde5eabdcabd91571f.fc08aec8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};